import React from "react";
import Icon from "./Icon";

/**
 * Context menu for file/folder actions.
 * Desktop: floating dropdown at cursor position with viewport-safe bounds.
 * Mobile (<=768px): full-width bottom sheet with slide-up animation.
 */
function ContextMenu({ x, y, item, onAction }) {
  if (!item) return null;

  const isFolder = item.type === "folder";

  const actions = [
    { key: "open", label: isFolder ? "Open Folder" : "Open", icon: "folder" },
    !isFolder && { key: "download", label: "Download", icon: "download" },
    { key: "divider1" },
    { key: "share", label: "Share Link", icon: "share", description: "Only shared users can access" },
    { key: "divider2" },
    { key: "rename", label: "Rename", icon: "pen" },
    { key: "permissions", label: "Manage Access", icon: "shield" },
    { key: "activity", label: "Activity Log", icon: "clock" },
    { key: "details", label: "Details", icon: "info" },
    { key: "divider3" },
    { key: "delete", label: "Delete", icon: "trash", danger: true },
  ].filter(Boolean);

  const isMobile = window.innerWidth <= 768;

  // Mobile: render as bottom sheet
  if (isMobile) {
    return (
      <>
        <div className="ctx-backdrop" />
        <div className="ctx-sheet">
          <div className="ctx-sheet-header">
            <div className="ctx-sheet-handle" />
            <div className="ctx-sheet-title">
              <Icon name={isFolder ? "folder" : "file"} size={18} />
              <span>{item.name}</span>
            </div>
          </div>
          <div className="ctx-sheet-items">
            {actions.map((action) => {
              if (action.key.startsWith("divider")) {
                return <div key={action.key} className="context-divider" />;
              }
              return (
                <button
                  key={action.key}
                  className={`context-item${action.danger ? " danger" : ""}`}
                  onClick={() => onAction(action.key, item)}
                >
                  <Icon name={action.icon} size={18} />
                  <div className="ctx-item-text">
                    <span>{action.label}</span>
                    {action.description && <small className="ctx-desc">{action.description}</small>}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </>
    );
  }

  // Desktop: viewport-safe floating dropdown
  const menuWidth = 220;
  const menuHeight = actions.length * 40;
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  let posX = x;
  let posY = y;
  if (posX + menuWidth > vw - 12) posX = vw - menuWidth - 12;
  if (posY + menuHeight > vh - 12) posY = vh - menuHeight - 12;
  if (posX < 12) posX = 12;
  if (posY < 12) posY = 12;

  return (
    <div
      className="context-menu"
      style={{ position: "fixed", top: posY, left: posX, zIndex: 9999 }}
      onClick={(e) => e.stopPropagation()}
    >
      {actions.map((action) => {
        if (action.key.startsWith("divider")) {
          return <div key={action.key} className="context-divider" />;
        }
        return (
          <button
            key={action.key}
            className={`context-item${action.danger ? " danger" : ""}`}
            onClick={() => onAction(action.key, item)}
          >
            <Icon name={action.icon} size={16} />
            <div className="ctx-item-text">
              <span>{action.label}</span>
              {action.description && <small className="ctx-desc">{action.description}</small>}
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default ContextMenu;
